/* Fornello Keukenlab — interactivity v3
 * - Video tab switcher
 * - Gated download modal (Klaviyo gating)
 */
(function () {
  // ===== Config (alleen Klaviyo public key + lead-list ID nodig) =====
  var KLAVIYO_PUBLIC_KEY = 'UBKDPT';
  var KEUKENLAB_LIST_ID = 'YrtDwh';

  // ===== 1. Video tab switcher =====
  document.querySelectorAll('[data-kl-tabs]').forEach(function (tabsEl) {
    var section = tabsEl.closest('section') || tabsEl.parentElement;
    var btns = tabsEl.querySelectorAll('.kl-tab-btn');
    var panels = section.querySelectorAll('.kl-tab-panel');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tk = btn.dataset.klTab;
        btns.forEach(function (b) {
          b.classList.toggle('kl-tab-btn--active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('kl-tab-panel--active', p.dataset.klPanel === tk);
        });
      });
    });
  });

  // ===== 2. Klaviyo gating modal =====
  window._learnq = window._learnq || [];

  var modal = null;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'kl-gate';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = ''
      + '<div class="kl-gate__backdrop" data-kl-close></div>'
      + '<div class="kl-gate__panel" role="document">'
      + '  <button type="button" class="kl-gate__close" aria-label="Sluiten" data-kl-close>×</button>'
      + '  <div class="kl-gate__form-state">'
      + '    <span class="kl-eyebrow">Gratis download</span>'
      + '    <h3 class="kl-gate__title">Hier krijg je je download</h3>'
      + '    <p class="kl-gate__intro">Vul je naam en e-mail in. We sturen de PDF direct naar je inbox, én openen \'m nu meteen.</p>'
      + '    <form class="kl-gate__form" novalidate>'
      + '      <label class="kl-gate__label" for="kl-gate-name">Voornaam</label>'
      + '      <input type="text" id="kl-gate-name" name="name" class="kl-gate__input" autocomplete="given-name" required placeholder="Bv. Steije">'
      + '      <label class="kl-gate__label" for="kl-gate-email">E-mail</label>'
      + '      <input type="email" id="kl-gate-email" name="email" class="kl-gate__input" autocomplete="email" required placeholder="naam@email.nl">'
      + '      <div class="kl-gate__error" role="alert" hidden></div>'
      + '      <button type="submit" class="kl-gate__submit">Stuur de PDF</button>'
      + '      <p class="kl-gate__consent">Door te versturen krijg je deze download én af en toe brood-tips van Fornello. Uitschrijven kan altijd.</p>'
      + '    </form>'
      + '  </div>'
      + '  <div class="kl-gate__success-state" hidden>'
      + '    <div class="kl-gate__success-icon" aria-hidden="true">✓</div>'
      + '    <h3 class="kl-gate__title">Top, je PDF staat klaar</h3>'
      + '    <p class="kl-gate__intro" data-kl-success-text>De download opent in een nieuw tabblad. We sturen \'m ook naar je mailbox.</p>'
      + '    <a href="#" target="_blank" rel="noopener" class="kl-gate__submit" data-kl-download-btn>Download opnieuw</a>'
      + '    <button type="button" class="kl-gate__secondary" data-kl-close>Verder kijken</button>'
      + '  </div>'
      + '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.matches('[data-kl-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('kl-gate--open')) closeModal();
    });

    var form = modal.querySelector('.kl-gate__form');
    form.addEventListener('submit', onSubmit);
    return modal;
  }

  function openModal(ctx) {
    ensureModal();
    modal._ctx = ctx;
    var formState = modal.querySelector('.kl-gate__form-state');
    var successState = modal.querySelector('.kl-gate__success-state');
    formState.hidden = false;
    successState.hidden = true;
    var errBox = modal.querySelector('.kl-gate__error');
    errBox.hidden = true;
    errBox.textContent = '';
    var submitBtn = modal.querySelector('.kl-gate__submit');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Stuur de PDF';
    var title = modal.querySelector('.kl-gate__title');
    if (ctx.downloadTitle) {
      title.textContent = ctx.downloadTitle;
    }
    document.body.style.overflow = 'hidden';
    modal.classList.add('kl-gate--open');
    setTimeout(function () {
      var emailInput = modal.querySelector('#kl-gate-email');
      var nameInput = modal.querySelector('#kl-gate-name');
      (nameInput.value ? emailInput : nameInput).focus();
    }, 50);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('kl-gate--open');
    document.body.style.overflow = '';
    // Abort pending async work zodat orphan callbacks geen stale state veroorzaken
    if (modal._timeoutId) {
      clearTimeout(modal._timeoutId);
      modal._timeoutId = null;
    }
    if (modal._xhr) {
      try { modal._xhr.abort(); } catch (e) { /* swallow */ }
      modal._xhr = null;
    }
    isSubmitting = false;
  }

  function showError(msg) {
    var errBox = modal.querySelector('.kl-gate__error');
    errBox.textContent = msg;
    errBox.hidden = false;
    var submitBtn = modal.querySelector('.kl-gate__submit');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Stuur de PDF';
  }

  var isSubmitting = false;

  function onSubmit(e) {
    e.preventDefault();
    if (isSubmitting) return;
    var ctx = modal._ctx || {};
    var firstName = (modal.querySelector('#kl-gate-name').value || '').trim();
    var email = (modal.querySelector('#kl-gate-email').value || '').trim();
    if (!firstName) { showError('Vul je voornaam in.'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showError('Vul een geldig e-mailadres in.'); return; }

    isSubmitting = true;
    var submitBtn = modal.querySelector('.kl-gate__submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Een momentje...';

    // KRITISCH: Open PDF NU binnen user-gesture (iOS/Safari blokkeert popups
    // na een setTimeout). Doe dit voor identify/track want SDK queue draait
    // toch op de achtergrond.
    var pdfWindow = null;
    try {
      pdfWindow = window.open(ctx.pdfUrl, '_blank', 'noopener');
    } catch (err) { /* swallow */ }

    var today = new Date().toISOString().slice(0, 10);
    var profileProps = {
      keukenlab_lead: true,
      keukenlab_last_product: ctx.product,
      keukenlab_last_download: ctx.product + '_' + ctx.downloadType,
      keukenlab_last_date: today
    };

    // 1. identify → server-side merge van basisprofiel + properties
    window._learnq.push(['identify', Object.assign({
      '$email': email,
      '$first_name': firstName
    }, profileProps)]);

    // 2. track event → flow trigger met alle event-properties incl. PDF url
    window._learnq.push(['track', 'Keukenlab Download Requested', {
      product: ctx.product,
      product_label: ctx.productLabel,
      download_type: ctx.downloadType,
      download_title: ctx.downloadTitle,
      pdf_url: ctx.pdfUrl,
      source: 'keukenlab'
    }]);

    // 2a. Voor Multicooker leads: ook de bestaande 'Multicooker Lead Identified'
    //     metric vuren zodat de huidige Welcome flow filter ze blijft weren.
    if (ctx.product === 'multicooker') {
      window._learnq.push(['track', 'Multicooker Lead Identified', {
        product: 'multicooker',
        source: 'keukenlab',
        download_type: ctx.downloadType
      }]);
    }

    // 3. Wacht 3.5s zodat SDK identify+track gepubliceerd zijn,
    //    dan subscribe via kmail-lists XHR (CORS-safe, omzeilt Shopify wpm).
    //    Bewaar timeout + xhr op modal zodat closeModal ze kan aborten.
    modal._timeoutId = setTimeout(function () {
      var fd = new URLSearchParams();
      fd.append('g', KEUKENLAB_LIST_ID);
      fd.append('email', email);
      fd.append('$first_name', firstName);
      fd.append('$consent', 'email');
      fd.append('$source', 'keukenlab-' + ctx.product);

      var xhr = new XMLHttpRequest();
      modal._xhr = xhr;
      xhr.open('POST', 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe', true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        var ok = xhr.status >= 200 && xhr.status < 300;
        try {
          var body = JSON.parse(xhr.responseText);
          if (ok && body && body.success === false) ok = false;
        } catch (e) { /* non-JSON ok */ }
        isSubmitting = false;
        if (ok) {
          showSuccess(ctx, pdfWindow, false);
        } else {
          showSuccess(ctx, pdfWindow, true);
          console.warn('Keukenlab subscribe non-2xx', xhr.status, xhr.responseText && xhr.responseText.slice(0, 200));
        }
      };
      xhr.onerror = function () {
        isSubmitting = false;
        showSuccess(ctx, pdfWindow, true);
        console.error('Keukenlab subscribe network error');
      };
      xhr.send(fd.toString());
      modal._timeoutId = null;
    }, 3500);
  }

  function showSuccess(ctx, pdfWindow, subscribeFallback) {
    var formState = modal.querySelector('.kl-gate__form-state');
    var successState = modal.querySelector('.kl-gate__success-state');
    var btn = modal.querySelector('[data-kl-download-btn]');
    var txt = modal.querySelector('[data-kl-success-text]');
    btn.href = ctx.pdfUrl;
    var popupOK = !!pdfWindow;
    if (!popupOK) {
      txt.textContent = 'Tik op de knop om je PDF te openen. We sturen \'m ook naar je mailbox.';
      btn.textContent = 'Open mijn PDF';
    } else if (subscribeFallback) {
      txt.textContent = 'De download opent in een nieuw tabblad. Mocht de mail niet aankomen, mail support@fornello.eu.';
      btn.textContent = 'Download opnieuw';
    } else {
      txt.textContent = 'De download opent in een nieuw tabblad. We sturen \'m ook naar je mailbox.';
      btn.textContent = 'Download opnieuw';
    }
    formState.hidden = true;
    successState.hidden = false;
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'keukenlab_download',
        product: ctx.product,
        download_type: ctx.downloadType
      });
    }
  }

  // ===== 3. Bind clicks =====
  document.addEventListener('click', function (e) {
    var el = e.target.closest('.kl-download');
    if (!el) return;
    var gated = el.dataset.gated === 'true';
    if (!gated) return; // open direct in nieuw tabblad
    e.preventDefault();
    var ctx = {
      product: el.dataset.productKey || (el.dataset.product || '').toLowerCase().split(' ')[0],
      productLabel: el.dataset.product || '',
      downloadType: el.dataset.type || '',
      downloadTitle: (el.querySelector('h4') && el.querySelector('h4').textContent || '').trim(),
      pdfUrl: el.getAttribute('href')
    };
    openModal(ctx);
  });
})();
